import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import {
  EntityWithMetadataTableSuffixColumns,
  createConnectionFilterSpec,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";
import { ReferenceVersionConnection } from "../../types/referenceVersion";
import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";

const columnHelper = createMRTColumnHelper<ReferenceVersionConnection>();

export const referenceVersionColumns: MRT_ColumnDef<
  ReferenceVersionConnection,
  any
>[] = [
  columnHelper.accessor("fromDoc", {
    header: "From",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("toDoc", {
    header: "To",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("version_reference_type", {
    header: "Reference Type",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),
  columnHelper.accessor("system_referring_to_version_connection_type", {
    header: "Connection Type",
    Cell: ({ cell }) => cell.getValue() || "-",
  }),
  ...EntityWithMetadataTableSuffixColumns,
];

export const referenceVersionFilterSpec: FilterSpec = createConnectionFilterSpec({
  version_reference_type: { kind: "string" },
  system_referring_to_version_connection_type: { kind: "string" },
});
